module.exports = __webpack_public_path__ + "img/only-monitor.d03f01af.svg";